<template>
  <div>
    <!-- 选择合并时的主数据 -->
    <el-dialog
      title="选择主要数据"
      :visible.sync="isMergeShow"
      :modal="false"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-radio-group v-model="mainRadish">
        <el-radio v-for="item in selectedRadishes" :key="item._id" style="margin-left:0;" :label="item._id">
          <span class="dialog-span drawer-link" @click="showRadish(item._id)">{{ item.姓名 }}</span>
          <span class="dialog-span" style="color:#aaa">{{ item.手机 }}</span>
          <span class="dialog-span">{{ item.公司 }}</span> <span class="dialog-span">{{ item.部门 }}</span>
          <span class="dialog-span">{{ item.目前职位 }}</span>
          <span class="dialog-span">
            <el-tag v-for="tag in item.职能模块" :key="tag" size="mini">{{ tag }}</el-tag>
          </span>
        </el-radio>
        <br />
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isMergeShow = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmMerge">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="radish-dia"
      title="请选择要绑定况客数据的人选"
      top="70px"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <div class="radish-dia-body" style="padding-bottom:10px">
        <div style="padding: 5px 0">
          <el-table
            border
            size="mini"
            :data="radishes"
            :resizable="false"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="40"> </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="doBind(scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <el-table-column label="姓名" prop="姓名" width="60"> </el-table-column>
            <el-table-column label="公司" prop="公司"></el-table-column>
            <el-table-column label="部门" prop="部门"></el-table-column>
            <el-table-column label="职能模块" prop="职能模块"></el-table-column>
            <el-table-column label="手机" prop="手机"></el-table-column>
          </el-table>
        </div>
      </div>
      <div style="padding: 10px 0">
        <el-button v-if="radishes.length > 1" type="primary" size="mini" @click="showMerge">合并并绑定</el-button>
        <el-button type="primary" size="mini" @click="doCreate">新建其他人选并绑定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    onSuccess: { type: Function, default: () => {} },
  },
  data: function() {
    return {
      dialogVisible: false,
      radishes: [],
      manager: {},
      selectedRadishes: [],
      isMergeShow: false,
      mainRadish: '',
    }
  },
  methods: {
    show: async function(manager) {
      // console.log(radishes)
      this.manager = manager
      const res = await app.service('radish').simpleList({
        query: { 姓名: manager.name, isDeleted: { $ne: true } },
        fields: { 姓名: 1, 手机: 1, 公司: 1, 部门: 1, 职能模块: 1 },
      })
      if (res.status === 'success') {
        this.radishes = res.data
      }
      this.dialogVisible = true
    },
    doBind: async function(row) {
      const res = await app.service('radish').bindManagers({ _id: this.manager._id, rid: row._id })
      if (res.status === 'success') {
        this.dialogVisible = false
        this.$message.success('绑定成功')
        this.onSuccess(this.manager._id, row._id)
      } else {
        this.$message.error(res.msg)
      }
    },
    doCreate: async function() {
      const result = await app.service('radish').insert({ 姓名: this.manager.name, 公司: this.manager.company })
      if (result.status === 'success') {
        const rid = result.data.id
        const res = await app.service('radish').bindManagers({ _id: this.manager._id, rid })
        this.onSuccess(this.manager._id, rid)
        this.dialogVisible = false
        this.$message.success('新建并绑定成功')
        window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
      }
    },
    showMerge() {
      if (this.selectedRadishes.length < 2) return this.$message('请选择至少勾选2个人选')
      this.mainRadish = ''
      this.isMergeShow = true
    },
    async confirmMerge() {
      if (!this.mainRadish) return this.$message('请选择以哪条数据为主')
      const first = this.mainRadish
      const second = this.selectedRadishes.map(v => v._id).filter(v => v !== first)

      const mergeRes = await app.service('radish').mergeMult({ id: first, first, second })
      if (mergeRes.status === 'success') {
        this.selectedRadishes = []
        this.isMergeShow = false
        const res = await app.service('radish').bindManagers({ _id: this.manager._id, rid: first })
        this.onSuccess(this.manager._id, first)
        this.dialogVisible = false
        this.$message.success('合并并绑定成功')
      } else this.$message(res.msg)
    },
    handleSelectionChange(val) {
      this.selectedRadishes = val
    },
    showRadish(rid) {
      if (!rid) return
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
    },
  },
}
</script>
